<template>
    <ContentPage title="Datenschutzerklärung" sub-title="Gemäß Art. 13 der Verordnung (EU) 2016/679">
        <p>
            Adorea S.r.l. (Fleequid), mit Sitz in Via provinciale per Bizzarone, 43 – 22077 Olgiate Comasco (CO), USt-IdNr. und Steuernummer
            04114790134, eingetragen im Handelsregister von Como unter der Nummer 04114790134, Stammkapital 10.000,00€ v.e. („
            <strong>Adorea S.r.l. (Fleequid)</strong>") informiert Sie als Verantwortlicher für die Datenverarbeitung hiermit über die Verarbeitung
            Ihrer personenbezogenen Daten gemäß Art. 13 der Verordnung (EU) Nr. 2016/679 („<strong>DSGVO</strong>").
        </p>

        <BaseVerticalStack as="ol" class="list-inside list-decimal">
            <li>
                <h3 class="text-highlighted inline-block font-bold">Zweck der Verarbeitung und Rechtsgrundlage</h3>
                <p class="my-4">
                    Adorea S.r.l. (Fleequid) ist ein Unternehmen, das sich mit der Verwaltung von Online-Auktionen für Nutzfahrzeuge für
                    Geschäftskunden befasst. Wenn sich ein Unternehmen bei Adorea S.r.l. (Fleequid) registriert, um an einer Auktion teilzunehmen,
                    werden einige Daten des jeweiligen Ansprechpartners abgefragt, nämlich Name, Vorname, E-Mail und Telefonnummer
                    („<strong>Daten</strong>"). Diese Daten werden von Adorea S.r.l. (Fleequid), auch mittels elektronischer/digitaler Instrumente,
                    ausschließlich für die folgenden Zwecke und Rechtsgrundlagen verarbeitet:
                </p>
                <div class="my-4 grid grid-cols-[40px_1fr_1fr] grid-rows-[24px_1fr_1fr] gap-2">
                    <div class="font-bold">Nr.</div>
                    <div class="font-bold">Zweck</div>
                    <div class="font-bold">Rechtsgrundlage</div>
                    <div class="font-bold">1.1</div>
                    <div>
                        Ermöglichung der Teilnahme an der Auktion wie vom Benutzer gewünscht, Gewährleistung des ordnungsgemäßen Ablaufs und der
                        Möglichkeit, den Ansprechpartner des Unternehmens im Falle eines Zuschlags zu kontaktieren
                    </div>
                    <div>Vertragserfüllung</div>
                    <div class="font-bold">1.2</div>
                    <div>Versand von Informationsmaterial zu den Dienstleistungen von Adorea S.r.l. (Fleequid)</div>
                    <div>
                        Berechtigtes Interesse gemäß Art. 130 Abs. 4 des Gesetzesdekrets 196/2003. Der Betroffene kann der Verarbeitung jederzeit
                        einfach und kostenlos widersprechen.
                    </div>
                </div>
                <p class="my-4">
                    Die Bereitstellung der personenbezogenen Daten ist für die Teilnahme an der Auktion und die Nutzung der Dienste von Adorea S.r.l.
                    (Fleequid) unerlässlich. Eine Nichtbereitstellung würde daher diese Teilnahme und die entsprechende Begründung des
                    Vertragsverhältnisses mit Adorea S.r.l. (Fleequid) beeinträchtigen.
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Weitergabe und Übermittlung der Daten</h3>
                <p class="my-4">
                    Die Daten können auch von Auftragnehmerunternehmen verarbeitet werden, die verbundene, instrumentelle oder unterstützende
                    Tätigkeiten für Adorea S.r.l. (Fleequid) ausführen und die Adorea S.r.l. (Fleequid) zur Erfüllung der oben genannten Zwecke
                    einsetzen kann. Diese handeln als Auftragsverarbeiter gemäß den Anweisungen von Adorea S.r.l. (Fleequid). Sollten bei der
                    Weitergabe von Informationen Daten in Länder außerhalb des Europäischen Wirtschaftsraums übermittelt werden, wird Adorea S.r.l.
                    (Fleequid) sicherstellen, dass die Daten in Übereinstimmung mit dieser Datenschutzerklärung und gemäß den geltenden
                    Datenschutzbestimmungen übermittelt werden.
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Aufbewahrung der Daten</h3>
                <p class="my-4">
                    Ihre Daten werden für den Zeitraum aufbewahrt, der zur Erfüllung der unter Punkt 1 genannten Zwecke unbedingt erforderlich ist,
                    d.h. 10 Jahre nach Beendigung der Vertragswirkungen. Diese Aufbewahrungsfrist ist hinsichtlich der Marketingzwecke durch die
                    besondere Art der bei den von Adorea S.r.l. (Fleequid) verwalteten Auktionen angebotenen Güter gerechtfertigt, nämlich
                    Nutzfahrzeuge von hohem Wert. Nach Ablauf dieses Zeitraums werden die Daten gelöscht oder anonymisiert.
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Rechte der betroffenen Person</h3>
                <p class="my-4">
                    Sie können jederzeit das Recht auf Zugang zu Ihren Daten und zu folgenden Informationen ausüben: Zweck der Verarbeitung;
                    Kategorien der betreffenden personenbezogenen Daten; Empfänger oder Kategorien von Empfängern, denen die Daten mitgeteilt werden
                    können; soweit möglich, die Dauer der Datenspeicherung gemäß Art. 15 DSGVO; das Recht auf Berichtigung unrichtiger
                    personenbezogener Daten gemäß Art. 16 DSGVO; das Recht auf Löschung der sie betreffenden Daten, sofern die Voraussetzungen des
                    Art. 17 DSGVO vorliegen; das Recht auf Einschränkung der Verarbeitung, sofern die Voraussetzungen des Art. 18 DSGVO vorliegen; das
                    Recht auf Datenübertragbarkeit, sofern die Voraussetzungen des Art. 20 DSGVO vorliegen; das Recht auf Widerspruch gegen die
                    Verarbeitung, einschließlich der Verarbeitung zu Marketingzwecken, sofern die Voraussetzungen des Art. 21 DSGVO vorliegen. Sie
                    können außerdem jederzeit eine Beschwerde bei der Datenschutzbehörde einreichen, wie auf der Website
                    <NuxtLink class="text-primary hover:underline" to="https://www.garanteprivacy.it" target="_blank" external>
                        www.garanteprivacy.it</NuxtLink
                    >
                    beschrieben.
                </p>
                <p class="my-4">
                    Für Anfragen oder Fragen zu unseren Datenschutzpraktiken wenden Sie sich bitte an uns unter
                    <FleequidEmailLink type="privacy" />. Wir beantworten alle Anfragen von Benutzern, die ihre Rechte im Bereich des Schutzes
                    personenbezogener Daten ausüben möchten, in Übereinstimmung mit den geltenden Datenschutzgesetzen.
                </p>
            </li>
        </BaseVerticalStack>
    </ContentPage>
</template>
